import script from "./ModalInscripcionEquipo.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalInscripcionEquipo.vue?vue&type=script&setup=true&lang=ts"

import "./ModalInscripcionEquipo.vue?vue&type=style&index=0&id=42c0db22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42c0db22"]])

export default __exports__